import axios from "axios";
import {API_URL} from "@/config/config";
// import { getAccessToken } from "./authentication";
const getAccessToken = () => localStorage.getItem('token') || '';
const token = getAccessToken();
export const commonHeaders = {
  'Accept': 'application/json',
  'Cache-Control': 'no-cache',
  'Pragma': 'no-cache',
  'Expires': '0',
  'Authorization': token ? `Bearer ${token}` : '',
  'X-Requested-With': 'XMLHttpRequest',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
  'Access-Control-Allow-Origin': '*',
  'app-name': 'dashboard',
  'system': 'web',
  'locale': 'en',
  'dashboard': true
}
const $http = axios.create({
  baseURL: API_URL,
  headers: {
    common: {
      'Content-Type': 'application/json',
      ...commonHeaders
    }
  }
});
// console.log("Updated Axios Default Headers:", axios.defaults.headers.common);
// console.log("http axios", $http.defaults.headers.common)
// window.h=$http
$http.interceptors.request.use(function (config) {
  return config;
});

export default $http;
